import React from 'react'

// Mirrors InputField's label / error / aria scaffold but renders a <select>
// whose <option> children the caller supplies. v7's InputField doesn't treat
// `children` as a field override (unlike the Bootstrap InputField), so here
// `children` is free to mean the options — no options-array prop, no
// normalization layer. Everything else (value, onChange, disabled, data-*)
// flows straight onto the <select> via ...selectProps.
//
// Used by the base form (ProjectSelect, PartnerItemSelect) AND handed to
// plugins via Pledge.components, so a plugin renders the same control the
// donor sees everywhere else on the form.
const SelectField = ({
  id, label, error, required, hideLabel = false, className, children, ...selectProps
}) => {
  const labelId = `${id}-label`
  const errorId = error && `${id}-error`

  return (
    <div>
      <label
        id={labelId}
        htmlFor={id}
        className={hideLabel ? 'sr-only' : 'block text-sm font-medium text-gray-700 mb-1'}
      >
        {label}
      </label>
      <select
        id={id}
        required={required}
        // Merge, don't let a caller's className drop form-select (the base
        // styles). Cursor lives in the .form-select CSS, not a utility here.
        className={`form-select ${className || ''}`.trim()}
        aria-labelledby={labelId}
        aria-describedby={errorId || undefined}
        aria-invalid={error ? 'true' : undefined}
        {...selectProps}
      >
        {children}
      </select>
      {error && (
        <p id={errorId} role="alert" className="mt-1 text-sm text-danger">
          {error}
        </p>
      )}
    </div>
  )
}

export default SelectField
